export const CLIENT_KEY = '6Ld2XeUUAAAAAGZIrQZOT-sU5ocvBKVAb5axS3iw';
